import { SplitPayment } from './SplitPayment'
export default SplitPayment